import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static targets = [
    'profit',
    'materialsCost',
    'price',
    'row',
    'formPrice',
    'enableToggle',
    'name',
  ]

  static values = {
    minPrice: Number,
    minProfit: Number,
    multiplier: Number,
    darkroomPercentage: Number,
    darkroomCost: Number,
    plus: Boolean,
    printTypeId: Number,
    enabled: Boolean,
  }

  connect = () => {
    on('pricingSliderAdjusted', this.adjust)
    on('productEnabled', this.flipEnabledToggle)
    on('productDisabled', this.flipEnabledToggle)
  }

  disconnect = () => {
    off('pricingSliderAdjusted', this.adjust)
    off('productEnabled', this.flipEnabledToggle)
    off('productDisabled', this.flipEnabledToggle)
  }

  adjust = (event) => {
    const newPrice = this.incrementPriceCents(
      this.minPriceValue,
      event.detail.value,
      this.multiplierValue,
    )
    this.setPrice(newPrice)
    this.setProfit(newPrice)
  }

  incrementPriceCents = (basePrice, incrementBy, multiplier) => {
    multiplier = parseInt(multiplier)
    const roundedPrice = Math.ceil((basePrice + (incrementBy * multiplier)) / 100) * 100
    return roundedPrice
  }

  formatDollars = (cents) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })

    cents /= 100
    return formatter.format(cents).replace(/\.00$/, '')
  }

  manualInput = (event) => {
    const floatRegex = /^\d+(\.\d{1,2})?$/

    if (floatRegex.test(this.priceTarget.value)) {
      const targetVal = parseInt(this.priceTarget.value)
      const newValue = (targetVal.toFixed(2)) * 100
      if (event.type !== 'keyup') {
        this.setPrice(newValue)
      }

      this.setProfit(newValue)
    }
  }

  setPrice = (price) => {
    if (this.plusValue) {
      this.priceTarget.value = (price / 100).toFixed(2).replace(/\.00$/, '')
    }
    else {
      this.priceTarget.innerHTML = this.formatDollars(price)
    }

    if (this.hasFormPriceTarget) {
      this.formPriceTarget.value = price
    }
  }

  setProfit = (price) => {
    this.profitTarget.innerText = this.formatDollars(this.calculateProfit(price))
  }

  calculateProfit = (price) => {
    const darkroomFees = this.calculateDarkroomFees(price)
    return price - darkroomFees
  }

  calculateDarkroomFees = (price) => {
    return (price * this.darkroomPercentageValue) + this.darkroomCostValue
  }

  setMaterialsCost = (price) => {
    this.materialsCostTarget.innerText = this.formatDollars(this.calculateDarkroomFees(price))
  }

  flipEnabledToggle = (event) => {
    if (!this.enabledValue || event.detail.id !== this.printTypeIdValue) return

    this.enableToggleTarget.checked = event.detail.enable
    this.enableToggleTarget.value = event.detail.enable
  }

  toggleSize = (event) => {
    const element = event.target

    element.form.requestSubmit()
  }

  get defaultFormData() {
    const formData = new FormData()
    formData.append(this.nameTarget.name, this.nameTarget.value)

    return formData
  }
}
